/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Proximity extends Component {
    constructor() {
        super();

        this.state = {
            isInProximity: false
        }
        this.onMouseMove = this.onMouseMove.bind(this);

        this.ref = React.createRef()
    }

    FindPoint(x1, y1, x2, y2, x, y) {

        return x > x1 && x < x2 && y > y1 && y < y2;

    }

    onMouseMove(e) {
        if (this.ref?.current !== undefined) {
            let {proximityX, proximityY} = this.props

            let currentElementDim = this.ref.current.getBoundingClientRect()

            if (this.FindPoint(currentElementDim.x - proximityX, currentElementDim.y - proximityY, currentElementDim.x + currentElementDim.width + proximityX, currentElementDim.y + currentElementDim.height + proximityY, e.clientX, e.clientY)) {
                if (!this.state.isInProximity) {
                    this.setState({isInProximity: true})
                }
            } else {
                if (this.state.isInProximity) {
                    this.setState({isInProximity: false})
                }
            }


        }

    }


    componentDidMount() {
        document.addEventListener('mousemove', this.onMouseMove);
    }

    componentWillUnmount() {
        document.removeEventListener('mousemove', this.onMouseMove);

    }

    render() {
        let {children, className} = this.props
        return (
            <div ref={this.ref} className={`${className}`}>
                {(typeof children === 'function') ? (children(this.state.isInProximity)) : (children)}
            </div>
        )
    }
}

Proximity.propTypes = {
    proximityX: PropTypes.any.isRequired,
    proximityY: PropTypes.any.isRequired,
    children: PropTypes.any
};

export default Proximity;